export type DrillDownFilterType =
  | 'visitor_hash'
  | 'country_code'
  | 'city'
  | 'browser'
  | 'os'
  | 'device_type'
  | 'referrer_source'
  | 'utm_campaign'
  | 'utm_term'
  | 'entry_page'

export interface DrillDownFilter {
  type: DrillDownFilterType
  value: string
  label: string // Human-readable label for display
}

export const FILTER_TYPE_LABELS: Record<DrillDownFilterType, string> = {
  visitor_hash: 'Visitor',
  country_code: 'Country',
  city: 'City',
  browser: 'Browser',
  os: 'Operating System',
  device_type: 'Device',
  referrer_source: 'Referrer',
  utm_campaign: 'Campaign',
  utm_term: 'Keyword',
  entry_page: 'Entry Page',
}
